import { render, staticRenderFns } from "./Patrol.vue?vue&type=template&id=48a2566d&scoped=true"
import script from "./Patrol.vue?vue&type=script&lang=js"
export * from "./Patrol.vue?vue&type=script&lang=js"
import style0 from "./Patrol.vue?vue&type=style&index=0&id=48a2566d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2566d",
  null
  
)

export default component.exports